import { Button, FormControlLabel, Radio, RadioGroup, Dialog, DialogContent } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import Webcam from "react-webcam";
import LocalSeeIcon from "@mui/icons-material/LocalSee";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddIcon from "@mui/icons-material/Add";
import colorConfigs from "../../../../configs/colorConfigs";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import axois from "../../../../configs/axois";
import baseURL from "../../../../configs/api";
import { handleCapture } from "../../../../utils/covertTheBase64FormatIntoImage";
import useAuth from "../../../../components/hooks/useAuth";
import { validateMin } from "../../../../utils/validateMin";
import { useTheme } from "../../../../components/hooks/useTheme";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import useDelete from "../../../../components/hooks/useDelete";
import { CustomImagePopup } from "../../../../components/common/CustomImagePopup";
import { put_fileUpload } from "../../../../services/appFileUpload";
import useConfirm from "../../../../components/hooks/useConfirm";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

export const EditVehicleType = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const idNumber = useLocation();
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { setDeletePopup, setData: setDeleteData }: any = useDelete();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const [label, setLabel] = useState<string>("");
  const [order, setOrder] = useState<string>("");
  const [maxFuellevel, setMaxFuellevel] = useState<string>("");
  const [active, setActive] = useState<string>("No");
  const [imageLocation, setImageLocation] = useState<string>("");
  const [filePath, setFilePath] = useState<any[]>([]);
  const [newFilePath, setNewFilePath] = useState<string[]>([]);
  const [imagePopup, setImagePopup] = useState<boolean>(false);
  const [fileIndex, setFileIndex] = useState<number>(-1);
  const [showWebcam, setShowWebcam] = useState<boolean>(false);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [isImageSaved, setIsImageSaved] = useState<boolean>(false);

  const webRef = useRef(null);
  const inputFileRef = useRef<HTMLInputElement>(null);
  const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPleaseWaitPopup(true);
    const selectedFiles = e.target.files as FileList;

    if (selectedFiles.length !== 0) {
      const formData = new FormData();
      formData.append("ImageFile", selectedFiles[0]);

      axios
        .post(`${baseURL}commonFile/upload`, formData, {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true,
        })
        .then((response) => {
          const newFilePath: any = {
            id: 0,
            fileName:
              `${baseURL}commonFile/Get?name=` +
              response.data,
          };
          setNewFilePath((prevPath: string[]) => [
            ...prevPath,
            newFilePath.fileName,
          ]);
          setFilePath((prevPath: any[]) => [...prevPath, newFilePath]);
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      setPleaseWaitPopup(false);
    }
  };


  const updateFile = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {

    setPleaseWaitPopup(true);
    const selectedFiles = e.target.files as FileList;
    if (selectedFiles.length !== 0) {
      const formData = new FormData();
      formData.append("ImageFile", selectedFiles[0]);
      axios
        .post(`${baseURL}commonFile/upload`, formData, {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true,
        })
        .then((response) => {

          put_fileUpload({
            id,
            attributeName: "VehicleType",
            attributeId: idNumber?.state,
            fileName: response.data,
            tabName: "VehicleType",
            userId: auth?.id ?? 0,
            createdDate: new Date()
          }, auth?.id, tenantId)
            .then(() => {
              setFilePath((prevPath: any[]) =>
                prevPath.map(file =>
                  file.id === id ? {
                    ...file, fileName: `${baseURL}commonFile/Get?name=` +
                      response.data,
                  } : file
                )
              );
              setPleaseWaitPopup(false);
              handleTenantError(null);
            })
            .catch((error) => {
              const errorMessage = error?.response?.data?.message || error?.message || "File upload failed.";
              setConfirmData({
                title: 'Warning',
                summary: errorMessage,
                confirmBtn: 'Ok',
                isConfirm: (callback: any) => {
                  callback();
                }
              });
              setConfirmPopup(true);
              setPleaseWaitPopup(false);
              handleTenantError(error);
            })
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      setPleaseWaitPopup(false);
    }


  }

  useEffect(() => {
    axois
      .get(`${baseURL}vehicleType/${idNumber?.state}`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setLabel(response?.data?.name);
        setOrder(response?.data?.order);
        setMaxFuellevel(response?.data?.maxFuelLevel);
        setActive(response?.data?.isActive ? "Yes" : "No");
        setImageLocation(response?.data?.imageLocation);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setPleaseWaitPopup(true);

    if (newFilePath.length !== 0) {
      newFilePath.forEach((item: string, index: number) => {
        axios
          .post(
            `${baseURL}fileUploadData?userId=${auth?.id}`,
            JSON.stringify({
              attributeName: "VehicleType",
              attributeId: idNumber?.state,
              fileName: item?.replace(
                `${baseURL}commonFile/Get?name=`,
                ""
              ),
              tabName: "VehicleType",
              userId: auth?.id ?? 0,
              createdDate: new Date(),
            }),
            {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
              },
              withCredentials: true,
            }
          )
          .then(() => {
            if (newFilePath.length - 1 === index) {
              setIsImageSaved(true);
            }
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      });
    } else {
      setIsImageSaved(true);
    }
  };

  useEffect(() => {
    if (isImageSaved) {
      axios
        .put(
          `${baseURL}vehicleType?userId=${auth?.id}`,
          JSON.stringify({
            id: idNumber?.state,
            name: label,
            order,
            maxFuellevel,
            isActive: active === "Yes",
            imageLocation,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          navigate(-1);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
      setIsImageSaved(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isImageSaved]);

  useEffect(() => {
    axios
      .get(`${baseURL}fileUploadData/GetFileUploadDatasByAttribute?attributeName=VehicleType&attributeId=${idNumber?.state}`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setFilePath(() =>
          response?.data?.map((item: any) => {
            return {
              id: item.id,
              fileName: item.fileName.startsWith("data:image/png;base64,")
                ? item.fileName
                : `${baseURL}commonFile/Get?name=` +
                item.fileName,
            };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteVehicleType = () => {
    setDeleteData({
      id: idNumber,
      tilte: `Delete`,
      summary: `Are you sure you want to delete this Vehicle Type?`,
      isDelete: (callback: any) => {
        fetch(`${baseURL}vehicleType?id=${idNumber?.state}&userId=${auth?.id}`, {
          method: 'DELETE',
          headers: {
            'X-Tenant-ID': tenantId,
          }
        })
          .then(() => {
            setPleaseWaitPopup(false);
            navigate(-1);
            callback();
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            callback();
            handleTenantError(error);
          });
      }
    });

    setDeletePopup(true);
  };

  const handleEdit = () => {
    setDisabled(false);
    setShowWebcam(false);
  };

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>
              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit Vehicle Type</h2>
                </div>

                {
                  disabled && (
                    <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                      onClick={handleEdit}
                    >
                      <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                        edit
                      </span>
                      <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                    </button>
                  )
                }
              </div>

              <div className="mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="w-full px-2">
                    <div className="grid grid-cols-3 gap-6">
                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Label</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={label}
                            disabled={disabled}
                            onChange={(e) => setLabel(e.target.value)}
                            required
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Max Fuel Level</label>
                          <input
                            type="number"
                            min={0}
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={maxFuellevel}
                            disabled={disabled}
                            onChange={(e) => setMaxFuellevel(validateMin(e.target.value, 0).toString())}
                            required
                          />
                        </div>

                        <div className="mt-2">
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Images</label>
                          <br />
                          {filePath.length !== 0 && (
                            <div className="flex flex-row items-center gap-[5px]">
                              {filePath.map((item: any, outerIndex: number) => {
                                return (
                                  <>
                                    <img
                                      src={item?.fileName}
                                      width={40}
                                      height={40}
                                      alt="repairOrder"
                                      onClick={() => {
                                        setFileIndex(outerIndex);
                                        setImagePopup(true);
                                      }}
                                    />
                                    <RemoveCircleIcon
                                      sx={{
                                        fontSize: "14px",
                                        color: colorConfigs.topbar.bg,
                                        fontWeight: "bold",
                                        "&: hover": {
                                          color: "red",
                                        },
                                      }}
                                      onClick={() => {
                                        setDeleteData({
                                          id: 0,
                                          tilte: `Delete`,
                                          summary: `Are you sure you want to delete this image?`,
                                          isDelete: (callback: any) => {
                                            let newFileSet: string[] = filePath.filter(
                                              (_, index: number) => index !== outerIndex
                                            );
                                            setFilePath(() => newFileSet);

                                            callback()
                                          }
                                        });

                                        setDeletePopup(true);
                                      }}
                                    />
                                  </>
                                );
                              })}
                            </div>
                          )}
                          <input
                            type="file"
                            accept="image/*"
                            ref={inputFileRef}
                            onChangeCapture={onFileChangeCapture}
                            style={{ display: "none" }}
                            disabled={disabled}
                          />
                          <div className="flex flex-row gap-2 mt-2">
                            <p
                              className="border border-dashed border-black rounded-sm px-[5px] py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                              onClick={(e) => {
                                if (inputFileRef.current !== null) {
                                  inputFileRef.current.value = "";
                                }
                                inputFileRef.current?.click();
                              }}
                            >
                              {" "}
                              <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                              Add Image
                            </p>

                            <p
                              className={`border border-dashed border-black rounded-sm px-[5px] py-[3px] flex justify-center items-center text-[12px] bg-white`}
                              onClick={() => setShowWebcam(true)}
                            >
                              {" "}
                              <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Order</label>
                          <input
                            type="number"
                            min={0}
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={order}
                            disabled={disabled}
                            onChange={(e) => setOrder(validateMin(e.target.value, 0).toString())}
                            required
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                          <RadioGroup
                            row
                            value={active}
                            onChange={(e) => setActive(e.target.value)}
                          >
                            <FormControlLabel
                              value="Yes" control=
                              {<Radio
                                disabled={disabled}
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": { color: "#167AC3" },
                                  "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                  "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                }}
                              />} label="Yes"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                                "&.Mui-disabled .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                              }}
                            />
                            <FormControlLabel value="No" control={
                              <Radio
                                disabled={disabled}
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": { color: "#167AC3" },
                                  "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                  "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                }}
                              />} label="No"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                                "&.Mui-disabled .MuiFormControlLabel-label": {
                                  color: themeStyles.form.labelTextColor,
                                },
                              }}
                            />
                          </RadioGroup>
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="flex gap-4 mt-6">
                      {
                        !disabled && (
                          <Button variant="contained"
                            sx={{
                              backgroundColor: colorConfigs.btn.main.bg
                            }}
                            type="submit"
                          >
                            Save
                          </Button>
                        )
                      }

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.delete.bg,
                        }}
                        onClick={deleteVehicleType}
                      >
                        Delete
                      </Button>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={showWebcam && !disabled}
        maxWidth="md"
        fullScreen={false}
        PaperProps={{
          style: {
            marginTop: "-16%",
          },
        }}
      >
        <DialogContent sx={{ padding: "0px" }}>
          <Webcam
            width={480}
            height={320}
            ref={webRef}
            screenshotFormat="image/png"
            audio={false}
            disabled={disabled}
          />

          <div className={`w-full h-[50px] flex flex-row justify-between px-4 py-2 ${themeStyles.main.tailwindSectionBg}`}>
            <div className="w-1/2">
              <Button variant="contained"
                sx={{
                  backgroundColor: colorConfigs.btn.cancel.bg,
                  border: colorConfigs.btn.cancel.border,
                  color: colorConfigs.btn.cancel.color
                }}
                onClick={() => setShowWebcam(false)}>
                Cancel
              </Button>
            </div>

            <div className="w-1/2 flex flex-row justify-end">
              <Button
                variant="contained"
                sx={{ backgroundColor: colorConfigs.btn.main.bg }}
                onClick={() => {
                  if (webRef.current !== null) {
                    //@ts-ignore
                    const imageSrc = webRef.current.getScreenshot();

                    handleCapture(imageSrc, `${baseURL}commonFile/upload`, tenantId, (imageFilePath: string) => {
                      if (imageFilePath) {
                        setFilePath((prevFileString: string[]) => [
                          ...prevFileString,
                          `${baseURL}commonFile/Get?name=${imageFilePath}`,
                        ]);
                      }
                    })

                    setShowWebcam(false);
                  }
                }}
              >
                Capture an Image
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <CustomImagePopup
        showPopup={imagePopup}
        handlePopup={() => setImagePopup(false)}
        filePath={filePath}
        fileIndex={fileIndex}
        setFileIndex={setFileIndex}
        imageBaseUrlPath="commonFile"
        updateFile={updateFile}
      />

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
};